
$(document).ready(function () {
  $(".image_slick").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    asNavFor: '.product_gallery'
  });
  $(".product_gallery").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.image_slick',
    centerMode: true,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 768,
        settings:{
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]	
  });
  
  $('.hero-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: true
  });
  $('.product-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: false,
    asNavFor: '.product-thumbs'
  });
  $('.product-thumbs').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    asNavFor: '.product-images',
    focusOnSelect: true
  });
  $('.place-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true
  });
  $('.set-menu-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
                 {
                   breakpoint: 767,
                   settings: {
                     slidesToShow: 1,
                     slidesToScroll: 1
                   }
                 }
                ]
  });


  $(".browse-title h5").click(function () {
    $(".shop-section .left ul").toggleClass("active");
  });

  jQuery(function () {
    function close_accordion_section() {
      $('.accordion-heading').removeClass('active');
      $('.accordion-content').slideUp(300).removeClass('open');
    }
    jQuery('.accordion-heading').click(function (e) {
      var currentAttrValue = $(this).data('id');
      if ($(this).hasClass('active')) {
        close_accordion_section();
      } else {
        close_accordion_section();
        $(this).addClass('active');
        $('#' + currentAttrValue).slideDown(300).addClass('open');
      }
      e.preventDefault();
    });
  });


  $('.rte img').addClass(
    function () {
      var floated = $(this).css('float');
      return floated ? 'img-' + floated : '';
    });

  $(".dataBg").css('background-image', function () {
    var bg = ('url(' + $(this).data("bg-src") + ')');
    return bg;
  });

  $('.header-initial .menu-bar button').click(function () {
    $('.site-header').addClass('visible');
     $('.site-header').removeClass('visible');
//     $('.header-initial').addClass('hidden');
  });

  $(window).scroll(function () {
    var sd = jQuery(window).scrollTop();
    if (sd > 0) {
      $('.site-header').addClass('sticky');
    } else {
      $('.site-header').removeClass('sticky');
    }
  });

  function heightAdjust() {
    $(".mobile-menu").css({
      "padding-top": $(".site-header").height()
    });
  }

  heightAdjust();
  $(window).resize(function () {
    heightAdjust();
  });

  $('.menu-opener').click(function () {
    $('.mobile-menu').toggleClass('open');
    $('body').toggleClass('menu-active');
  });

  $('.cart-icon').click(function () {
    $('.mini-cart').toggleClass('active');
  });

  $('.submenuOpen').click(function () {
    $(this).parent().toggleClass('active');
    $(this).parent().children('.mobile-submenu').slideToggle();
  });

  var $nav = $('.header-initial'),
      $win = $(window),
      winH = $win.height(); // Get the window height.

  $win.on("scroll", function () {
    $nav.toggleClass("visible", $(this).scrollTop() > winH);
  }).on("resize", function () { // If the user resizes the window
    winH = $(this).height(); // you'll need the new height value
  });

  $(window).resize(function () {
    var cw = $('.product-image').width();
    $('.product-image').css({
      'height': cw + 'px'
    });
    $('.product-image img').css({
      'height': cw + 'px'
    });
  });


  // tabbed content
  // http://www.entheosweb.com/tutorials/css/tabs.asp
  $(".tab_content").hide();
  $(".tab_content:first").show();

  /* if in tab mode */
  $("ul.tabs li").click(function () {

    $(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $("#" + activeTab).fadeIn();

    $("ul.tabs li").removeClass("active");
    $(this).addClass("active");

    $(".tab_drawer_heading").removeClass("d_active");
    $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function () {

    $(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    $("#" + d_activeTab).fadeIn(100);

    if ($(this).hasClass('d_active')) {
      var d_activeTab = $(this).attr("rel");
      $("#" + d_activeTab).fadeOut(100);
    }

    $(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");

    $("ul.tabs li").removeClass("active");
    $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
  });

  $('ul.tabs li').last().addClass("tab_last");
  
  
  //   for zoom image
  $(document).ready(function(){
    if ($(window).width() >= 767) {
      $(".image_slick").find('.fan-fav-img').zoom({ magnify:2, on: 'click'});
      $(".image_slick").find('.fan-fav-img').hover(function () {
        $(".image_slick").find('.fan-fav-img').zoom({ magnify:2, on: 'click'});
      }, 
      function () {
        $(".image_slick").find('.fan-fav-img').trigger('zoom.destroy');
      }
     );
    }
    if ($(window).width() < 767) {
      $('body').on('click', '.fan-fav-img', function(e){
        var ss = $(this).find('img').attr('src');
        var d = '<div class="img_zoom_main"><div class="img_zoom"><img  loading="lazy" src="'+ss+'"></div><div class="remove">X</div></div>';
        $('body').append(d);
        $('.main-header').hide();
        $('.announcement').hide();
      });
    }
  });
  $('body').on('click','.img_zoom_main .remove', function(){
    $(this).parents('.img_zoom_main').hide();
  });
  
  
  
  
  
  /*  start file_name - free_product_mini_cart.liquid - add and remove bundle product js on add to cart button */
  var n_id;
  function removeitem(n_id){
    $.ajax({
      type: "post",
      dataType: 'json',
      data:'updates['+n_id+']=0',
      url:'/cart/update.js',
      async: false,
      success: success_fun
    });
  }
  function success_fun(){
    var hh = 'https://shradhdha-cirkle.myshopify.com/cart?view=mini';
    $.get(hh, function(data){
      $('.cart_pop').html(data);
    });
    $('.cart_popup').show();
    $.getJSON('/cart.js', function(cart){
      $('.cart_count').find('.item_count').text(cart.item_count);
    });
  }
  $('body').on('click', '.free_ct .add_cart_btn_free', function(e){
    e.preventDefault();
    var link = $(this).parents().find('.form_free');
    var id = 40372215873687;
    var id1 = 37461172551831;

    $.getJSON('/cart.js', function(cart){
      var arr = [];
      for(var i in cart.items){
        arr.push(cart.items[i].id);
      }
      var cart_total = cart.total_price;
      if( cart_total <= 200000 && jQuery.inArray(id ,arr) != -1){
        removeitem(id);
      }
      else if( cart_total > 200000 && jQuery.inArray(id,arr) != -1 && jQuery.inArray(id1,arr) != -1){
        removeitem(id);
        removeitem(id1);
      }
    });
    setTimeout(function(){
      $.each(link, function(index, val){
        var id = val.id;
        $.ajax({
          dataType: 'JSON',
          type: 'post',
          async: false,
          data: $(id).serialize(),
          url: '/cart/add.js',
          success: success_fun
        });
      });
    }, 2000);
  });
    
  /*  end file_name - free_product_mini_cart.liquid - add and remove bundle product js on add to cart button */

  
  
  
  
});

$(window).load(function () {
  var time = $('.landing-logo').attr('data-hide-time') * 1000;
  setTimeout(function () {
    $('.landing-logo').fadeOut();
    $('.landing-logo').next().delay(400).fadeIn('300');
    //console.log(time);
  }, time);
});


document.addEventListener("DOMContentLoaded", function (e) {
  function t(e, t) {
    return (" " + e.className + " ").indexOf(" " + t + " ") > -1
  }

  window.onclick = function () {
    for (var e = document.getElementsByClassName("selectbox-options"), t = 0; t < e.length; t++) e[t].setAttribute("class", "selectbox-options selectbox-options--hidden")
      };
  for (var s = document.getElementsByClassName("justselect"), n = 0; n < s.length; n++) {
    s[n].required = !0, s[n].onchange = function () {
      var e = document.getElementsByClassName("selectbox__label"),
          t = this.value,
          s = this.dataset.sid,
          n = this.options;
      for (a = 0; a < e.length; a++)
        if (e[a].parentElement.dataset.pair === s) {
          for (b = 0; b < n.length; b++)
            if (n[b].value == t) {
              e[a].innerHTML = n[b].innerHTML;
              break
            }
          break
        }
    };
    var o = s[n].options,
        l = document.createElement("div");
    l.setAttribute("class", "selectbox"), l.setAttribute("data-pair", "select-" + (n + 1));
    var i = document.createElement("div");
    i.setAttribute("class", "selectbox__label"), l.appendChild(i);
    var c = document.createElement("div");
    c.setAttribute("class", "selectbox-options selectbox-options--hidden");
    for (var r = 0; r < o.length; r++) {
      var d = document.createElement("div");
      d.setAttribute("class", "selectbox__option"), d.setAttribute("data-value", o[r].value), !0 === o[r].selected && (d.setAttribute("class", d.className + " selectbox__option--selected"), i.innerHTML = o[r].text), o[r].disabled || (d.innerHTML = o[r].text, c.appendChild(d), l.appendChild(c))
    }! function (e, t) {
      e.parentNode.insertBefore(t, e.nextSibling)
    }(s[n], l), s[n].setAttribute("data-sid", "select-" + (n + 1)), s[n].style.display = "none"
  }
  for (var u = document.getElementsByClassName("justselect"), p = 0; p < u.length; p++) {
    var m = document.createElement("div");
    m.setAttribute("class", "justwrap");
    var h = document.getElementsByClassName("selectbox");
    u[p].parentElement.insertBefore(m, u[p]), h[p].parentElement.insertBefore(m, h[p]), m.appendChild(u[p]), m.appendChild(h[p])
  }
  for (var v = document.getElementsByClassName("selectbox__label"), x = 0; x < v.length; x++) v[x].onclick = function (e) {
    e.stopPropagation();
    var s = this,
        n = this.nextSibling,
        o = n.children;
    t(n, "selectbox-options--hidden") ? n.setAttribute("class", "selectbox-options") : n.setAttribute("class", "selectbox-options selectbox-options--hidden");
    for (var a = 0; a < o.length; a++) o[a].onclick = function () {
      for (var e = 0; e < o.length; e++) e != a && o[e].setAttribute("class", "selectbox__option");
      s.innerHTML = this.innerHTML, this.setAttribute("class", "selectbox__option selectbox__option--selected"), document.querySelectorAll('[data-sid="' + s.parentElement.dataset.pair + '"]')[0].value = this.dataset.value, n.setAttribute("class", "selectbox-options selectbox-options--hidden")
    }
      }
    });


/* start js for build own gift product */
$(document).ready(function () {
  $('body').on('click', '.image_one a img', function(){
    $('.img_one').find('a img').removeClass('sel_border');
    $('.img_two').find('a img').removeClass('sel_border');
    $(this).addClass('sel_border');
  });
  $('body').on('click', '.image_selected_part_second .ticket', function(){
    $('.ticket').removeClass('sel_border');
    $('.ticket').removeClass('sel_border');
    $(this).addClass('sel_border');
  });
  $('body').on('click', '.all_product .add_form_1', function(){
    $('.add_form_1').find('.product_image_1').removeClass('sel_border');
    $('.add_form_1').find('.product_image_1').removeClass('sel_border');
    $(this).find('.product_image_1').addClass('sel_border');
  });
  $('body').on('click', '.all_product .add_form_2', function(){
    $('.add_form_2').find('.product_image_2').removeClass('sel_border');
    $('.add_form_2').find('.product_image_2').removeClass('sel_border');
    $(this).find('.product_image_2').addClass('sel_border');
  });
  $('body').on('click', '.all_product .add_form_3', function(){
    $('.add_form_3').find('.product_image_3').removeClass('sel_border');
    $('.add_form_3').find('.product_image_3').removeClass('sel_border');
    $(this).find('.product_image_3').addClass('sel_border');
  });
  if($('.image_selected_part_first').hasClass('common_display')){
    $('.pre_btn').hide();
  }
  
  $('body').on('click', '.next_btn', function(){
    var comm_find = $('.all_div').find('.common_display').find('.sel_border');
    if(comm_find.length > 0 ){
      if($('.list_ul').find('.title_num').hasClass('active_li')){
        $('.list_ul').find('.active_li_next').removeClass('active_li_next');
        $('.list_ul').find('.active_li').removeClass('active_li').parent().next().find('.title_num').addClass('active_li').parent().next().find('.title_num').addClass('active_li_next');
      }
      var id = $('.list_ul').find('.active_li').text();
      var step = "step"+id;
      if($('.all_div').find('.'+step).removeClass('common').addClass('common_display')){
        $('.pre_btn').show();
      }
      if($('.common_display').hasClass('step5')){
        $('.next_btn').hide();
        $('.pre_btn').hide();
      }
      if($('.two_ticket').hasClass('sel_border')){
        $('.all_div').find('.co_div').removeClass('common_display').addClass('common');
        $('.all_div').find('.step00').removeClass('common').addClass('common_display last_display');
        if($('.title_num').hasClass('active_li')){
          $('.title_num').removeClass('active_li').removeClass('active_li_next');
          $('.title_num.last').addClass('active_li');
          if($('.common_display').hasClass('step00')){
            $('.next_btn').hide();
            $('.pre_btn').hide();
          }
        }
      }
      else{
        $('.all_div').find('.common_display').removeClass('common_display').addClass('common');
        $('.all_div').find('.'+step).removeClass('common').addClass('common_display');
      }
      $('body').on('click','.all_product .id_parent img', function(){
          $(this).parents('.id_parent').removeClass('pro_sele_img');
          $(this).parents('.id_parent').addClass('pro_sele_img');
      });
    }
  });
  $('body').on('click', '.pre_btn', function(){
    if($('.image_selected_part_second').hasClass('common_display')){
      $('.pre_btn').hide();
    }
    else{
      $('.pre_btnn').show();
    }
    $('body').on('click', '.next_btn', function(){
      $('.pre_btnn').show();
    });
    if($('.list_ul').find('.title_num').hasClass('active_li')){
      $('.list_ul').find('.active_li_next').removeClass('active_li_next');
      $('.list_ul').find('.active_li').removeClass('active_li').parent().prev().find('.title_num').addClass('active_li').parent().next().find('.title_num').addClass('active_li_next');
    }
    var id = $('.list_ul').find('.active_li').text();
    var step = "step"+id;
    if($('.two_ticket').hasClass('sel_border')){
      $('.all_div').find('.co_div').removeClass('common_display').addClass('common');
      $('.all_div').find('.step00').removeClass('common').addClass('common_display last_display');
      if($('.title_num').hasClass('active_li')){
        $('.title_num').removeClass('active_li').removeClass('active_li_next');
        $('.title_num.last').addClass('active_li');
        if($('.common_display').hasClass('step00')){
          $('.next_btn').hide();
          $('.pre_btn').hide();
        }
      }
    }
    else{
      $('.all_div').find('.common_display').removeClass('common_display').addClass('common');
      $('.all_div').find('.'+step).removeClass('common').addClass('common_display');
    }
  });
  
  $('body').on('click', '.add_to__cart', function(){
    if($('.common_display').hasClass('step00')){
      var form1 = $('.last_display').find('.add_to_cart_a');
      $.each(form1, function(index,val){
        var id = val.name;
        $.ajax({
          type:'POST',
          url: '/cart/add.js',
          dataType:'json',
          async: false,
          data:$('#'+id).serialize()
        });
      }).done(addtocart());
    }
    else if($('.common_display').hasClass('step5')){
      var form = $('.pro_sele_img').find('form');
      $.each(form, function(index,val){
        var id = val.name;
        $.ajax({
          type:"POST",
          url: '/cart/add.js',
          dataType:"json",
          async: false,
          data:$('#'+id).serialize()
        });
      }).done(addtocart());
    }
    function addtocart(){
      var href = $('.add_to_cart_a').attr('action').replace('/add','')+'?view=mini';
      $.get( href, function( data ) {
        $('.cart_pop').html(data);
      });
      $('.cart_popup').show();
      $.getJSON("/cart.js", function(cart) {
        $('.item_count').text(cart.item_count);
      });
    }
  });
});

/* end js for build own gift product */


/* start mix-match section JS */
$(document).ready(function(){
    $('.sli-item').hover(function() {
      var c = $(this).find('img').data('index');
      $('.add_doc').hide();
      $('.ned_add_'+c).show();
      $('.sli-item').removeClass('active');
      $('.cSlider--single').slick('slickGoTo', c);
      $(this).addClass('active');
     }, function() {
      console.log('else');
    });
    $('.cSlider--single').slick({
      autoplay: false, 
      slidesToShow: 1,
      infinite: true,
      loop:true,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.cSlider--nav',
      responsive: [{  
        breakpoint: 768,
        settings: {
          slidesToShow: 1, 
          slidesToScroll: 1,
        }
      }
     ]
    });
    $('.cSlider--nav').slick({
      autoplay: false, 
      loop:true,
      slidesToShow: 4,
      infinite: true,
      slidesToScroll: 1,
      asNavFor: '.cSlider--single',
      dots: false, 
      focusOnSelect: true,
      responsive: [{  
        breakpoint: 768,
        settings: {
          slidesToShow: 2, 
          vertical:true,
          centerMode:true,
          verticalSwiping:true,
          slidesToScroll: 1,
        }
      }
     ]
    }); 
});
/* end mix-match section JS */



/* Main product with one other product add in cart/minicart */
$(document).ready(function(){
  var d = new Date().getTime();
  var random = Math.floor((Math.random() * d * 10) + 1);
  $('.bundleId').val(random);

  $('body').on('click', '.upsell_add_cart', function(e){
    e.preventDefault();
    //     var bundleID = $(this).closest('.upsell__holder').find('.bundleId').val();
    var main_pro_id = $('input[type="radio"]:checked').data('id');
    var upsell_pro_id = $(this).closest('.upsell__holder').find('.upsell_common').val();
    var items = [
      { quantity: 1, id: main_pro_id },
      { quantity: 1, id: upsell_pro_id }
    ];
    $.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: { items: items },
      dataType:"json",
      async: false,
      success: function(data) {
        var href = 'https://shradhdha-cirkle.myshopify.com/cart?view=mini';
        $.get( href, function( data ) {
          $('.cart_pop').html(data);
        });
        $('.cart_popup').show();
        $.getJSON('/cart.js', function(cart){
          $('.cart_count').find('.item_count').text(cart.item_count);
        });
      }    
    });
  });
});
/* Main product with one other product add in cart/minicart */